/** saves the payments operators list
@payload { Object } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_paymentsoperators
*/
export const SAVE_OPERATORS_LIST = (state, payload) => {
    state.paymentsOperatorsList = payload

    const parsedPaymentsOperatorsListNames = []

    state.paymentsOperatorsList.forEach(operatorGroups => {
        operatorGroups.children.forEach(operator => {
            operator.children.forEach(elem => {
                elem.parentName = operator.name
                elem.operatorGroupName = operatorGroups.name
                parsedPaymentsOperatorsListNames.push(elem)
            })
        })
    })

    state.parsedPaymentsOperatorsListNames = parsedPaymentsOperatorsListNames
}

/** saves the payments list
@payload { Object } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_paymentssearch
*/
export const SAVE_PAYMENTS_LIST = (state, payload) => {
    state.paymentsList = payload
}

/** saves the favorites list
@payload { Object } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_favoriteslist
*/
export const SAVE_FAVORITES_LIST = (state, { pageNumber, data }) => {
    state.favoritesList = pageNumber === 1 ? data.favorites : state.favoritesList.concat(data.favorites)
    state.favoritesHasMore = state.favoritesList.length < data.total
}

/** saves the favorites tabs
@payload { Object } - Without Documentation
*/
export const SAVE_FAVORITES_TABS = (state, payload) => {
    state.favoritesTabs = payload
}

/** saves payment detail
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_payments%7Bid%7D
*/
export const SAVE_PAYMENT_DETAIL = (state, payload) => {
    state.paymentDetail = payload
}

/** saves frequent operations
@payload { Array } - list of frequent operations
*/
export const SAVE_FREQUENT_OPERATIONS = (state, payload) => {
    state.frequentOperations = payload
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
/** Clears Payments Services Feature states */
export const CLEAR_PAYMENTS_SERVICES_STATE = (state, payload) => {
    state.paymentsList = []
    state.favoritesList = []
    state.favoritesHasMore = false
    state.favoritesTabs = []
    state.paymentDetail = null
}
